interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页">
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-[20px]" aria-hidden="true"></i>
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`h-9 min-w-[36px] cursor-pointer rounded-md px-3 text-sm transition-colors ${
            p === page
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-500"
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-200 disabled:hover:text-foreground-700"
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-[20px]" aria-hidden="true"></i>
      </button>
    </nav>
  );
}